'use client';

import { authService } from '@/lib/authService';

interface VendorMemoryRecordParams {
  vendor_name: string;
  account_code?: string | null;
  account_name?: string | null;
  contact_id?: number | null;
  contact_name?: string | null;
  line_item_description?: string | null;
  action?: 'record' | 'reject';
  work_item_id?: string;
}

/**
 * Fire-and-forget POST to the vendor-memory endpoint.
 * Never blocks UI — failures are silently logged.
 */
export function recordVendorMemory(params: VendorMemoryRecordParams): void {
  if (!params.vendor_name?.trim()) return;

  const token = authService.getTokens()?.access_token;

  fetch('/api/v1/finance/vendor-memory', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({
      vendor_name: params.vendor_name.trim(),
      account_code: params.account_code || undefined,
      account_name: params.account_name || undefined,
      contact_id: params.contact_id || undefined,
      contact_name: params.contact_name || undefined,
      line_item_description: params.line_item_description || undefined,
      action: params.action || 'record',
      work_item_id: params.work_item_id,
    }),
  }).catch((err) => {
    console.warn('[vendorMemory] Failed to record:', err);
  });
}
